// can be used on both server-side and client-side

import {pricesEmpty} from './pricesEmpty'
import {Prices, PricesV2} from './types'

// Module-level cache — lives for the entire server lifetime, survives HMR reloads
const globalCache = global as typeof global & {pricesCache?: Prices} & {pricesV2Cache?: PricesV2}

function getPricesCache(): Prices {
  if (!('pricesCache' in globalCache)) {
    globalCache.pricesCache = pricesEmpty
  }
  return globalCache.pricesCache!
}

function getPricesV2Cache(): PricesV2 {
  if (!('pricesV2Cache' in globalCache)) {
    globalCache.pricesV2Cache = []
  }
  return globalCache.pricesV2Cache!
}

let pricesInjected = false

// Fills the prices cache with the data the server rendered the page with.
//
// A prerendered page has no prices to hand over — it renders on the empty cache and the browser
// picks the real ones up from the first per-request page it navigates to. So the flag has to mean
// "the cache was filled", not "this was called": latching it on an absent payload would make that
// later call a no-op and leave every consumer reading zeros for the rest of the session.
export const injectPrices = (data: Prices | null) => {
  if (pricesInjected || !data) {
    return
  }
  Object.assign(getPricesCache(), data)
  pricesInjected = true
}

let pricesV2Injected = false

// See the note on injectPrices: the same latch, with the same reason for guarding it.
export const injectPricesV2 = (data: PricesV2 | null | undefined) => {
  if (pricesV2Injected || !data) {
    return
  }
  Object.assign(getPricesV2Cache(), data)
  pricesV2Injected = true
}

export const prices = getPricesCache()
export const pricesV2 = getPricesV2Cache()
